<template>
  <a-config-provider :locale="zhCN">
    <div class="app">
      <div class="app-content">
        <div v-if="preloaded">
          <b-main @close="mainFn"/>
          <q-dialog v-if="!authorized" :value="true" persistent>
            <b-login @success="loginSuccess"/>
          </q-dialog>
        </div>
        <div v-else-if="authorized" class="app-center">
          <q-spinner-cube color="primary" size="5.5em" />
        </div>
        <div v-else class="app-center app-login">
          <b-login-page />
        </div>
        <q-dialog v-model="dialogs.notify.show">
          <b-fake-notify />
        </q-dialog>
      </div>
    </div>
  </a-config-provider>
</template>
<script>
import '@/styles/app.scss'
import zhCN from 'ant-design-vue/es/locale/zh_CN'
import { createNamespacedHelpers } from 'vuex'
import BLogin from '@/views/app/BLogin'
import BLoginPage from '@/views/app/BLoginPage.vue'
import BMain from '@/views/app/BMain'
import BFakeNotify from '@/views/app/BFakeNotify.vue'
import utils from '@/lib/utils'
import { Shortcuts } from 'shortcuts'

const {
  mapGetters: mapAuthorizeGetters,
  mapMutations: mapAuthorizeMutations
} = createNamespacedHelpers('bis/authorize')

const {
  mapGetters: mapWordGetters
  // mapMutations: mapWordMutations,
  // mapActions: mapWordActions
} = createNamespacedHelpers('bis/word')

const {
  mapGetters: mapDicGetters,
  // mapMutations: mapDicMutations,
  mapActions: mapDicActions
} = createNamespacedHelpers('bis/dic')

const shortcuts = new Shortcuts()

export default {
  components: { BLogin, BMain, BFakeNotify, BLoginPage },
  data () {
    return {
      zhCN,
      displayLogin: false,
      unactiveTimer: null,
      preloading: false,
      dialogs: {
        notify: {
          show: false
        }
      }
    }
  },
  computed: {
    ...mapAuthorizeGetters({
      authorized: 'authorized',
      authorizeFetched: 'fetched'
    }),
    ...mapWordGetters(['wordsLoaded']),
    ...mapDicGetters({
      dicModelsLoaded: 'allModelsLoaded'
    }),
    isDark () {
      return this.$q.dark.isActive
    },
    preloaded () {
      return this.authorizeFetched
    },
    shouldPreload () {
      return this.authorized && !this.preloaded
    }
  },
  watch: {
    async shouldPreload (val) {
      if (val) {
        this.preload()
        // this.activeFn()
      }
    },
    isDark: {
      immediate: true,
      handler: function (dark) {
        console.log('themeBg', utils.getThemeColor(dark ? 'dark' : 'theme-bg-light'))
        utils.setThemeColor('themeBg', utils.getThemeColor(dark ? 'dark' : 'theme-bg-light'))
      }
    }
  },
  async mounted () {
    window.addEventListener('load', this.refresh)
    if (this.shouldPreload) {
      this.preload()
    }
    shortcuts.add({
      shortcut: 'Alt+N',
      handler: event => {
        this.dialogs.notify.show = !this.dialogs.notify.show
      }
    })
  },
  beforeDestroy () {
    shortcuts.reset()
  },
  methods: {
    mainFn (openOrClose) {
      this.displayLogin = openOrClose
    },
    loginSuccess () {
      this.activeFn()
    },
    ...mapAuthorizeMutations({
      storeFetch: 'fetch'
    }),
    // ...mapWordActions(['loadWords']),
    ...mapDicActions({
      loadDicModels: 'loadModels'
    }),
    // async preloadWord () {
    //   return await this.loadWords()
    // },
    async preloadDic () {
      return await this.loadDicModels()
    },
    async preload () {
      if (!this.shouldPreload || this.preloading) {
        return
      }
      this.preloading = true
      await Promise.all([
        // this.preloadWord(),
        this.preloadDic()
      ])
      this.preloading = false
      if (this.shouldPreload) {
        setTimeout(() => {
          // this.preload()
        }, 5000)
      }
    },
    activeFn () {
      this.displayLogin = false
      // clearTimeout(this.unactiveTimer)
      // this.unactiveTimer = setTimeout(() => {
      //   // 5min无人操作之后,展示登录框
      //   this.displayLogin = true
      // }, 5 * 60 * 1000)
    }
  }
}
</script>
<style lang="scss">
.app {
  height: 100vh;
  overflow: hidden;
  .app-content {
    height: 100vh;
    overflow: hidden;
  }
}
.app-center {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.app-print {
  width: 100%;
  height: 100%;
}
.app-login {
  background-image: url("~@/assets/bg.png");
  background-size: cover; // contain
  background-position: center;
  background-repeat: no-repeat;
}
</style>
